module.exports = __webpack_public_path__ + "img/logo_footer.2438fa49.webp";